import React from 'react';
import { Link } from 'react-router-dom';

const EdgePaisa: React.FC = () => {
  return (
    <div className="edge-paisa-page">
      {/* Page Header */}
      <div className="relative bg-primary py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-4 animate-fadeInDown">EDGE PAISA</h1>
          <p className="text-white text-xl mb-4 animate-fadeInUp">Bharat Ki Digital Dukan</p>
          <p className="text-secondary text-2xl font-semibold animate-fadeInUp">One Shop. Endless Services.</p>
          <nav className="flex justify-center animate-fadeInUp mt-4">
            <ol className="flex items-center space-x-2 text-white">
              <li><Link to="/" className="hover:text-secondary">Home</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li><Link to="/services-for-bharat" className="hover:text-secondary">Services for Bharat</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li className="text-secondary">Edge Paisa</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* About Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-6">About Us – Edge Paisa</h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                Edge Paisa is a leading fintech platform dedicated to bringing essential digital and financial services to every corner of Bharat. With the mission of enabling <strong>"One Shop, Endless Services,"</strong> Edge Paisa empowers retailers, entrepreneurs, and local businesses to become <strong>Digital Dukans</strong> for their communities.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-lg shadow-md mb-12 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
              <p className="text-gray-700 text-lg leading-relaxed text-center">
                We aim to bridge the gap between banking services and the people of Bharat, especially in <strong>rural and semi-urban areas</strong>, ensuring that every citizen has easy access to secure, fast, and reliable financial solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Vision */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp">
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="fas fa-eye text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-center">Our Vision</h3>
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  To create a <strong>digitally empowered Bharat</strong> where every individual can access financial services anytime, anywhere.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed text-center">
                  We envision a future where digital finance is simple, accessible, and beneficial for all.
                </p>
              </div>

              {/* Mission */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="fas fa-bullseye text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-center">Our Mission</h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <i className="fas fa-check-circle text-secondary text-xl mr-3 mt-1"></i>
                    <span>To enable local shops to become full-fledged digital service centers</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check-circle text-secondary text-xl mr-3 mt-1"></i>
                    <span>To simplify financial services for customers across Bharat</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check-circle text-secondary text-xl mr-3 mt-1"></i>
                    <span>To empower youth, retailers, and entrepreneurs through fintech opportunities</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check-circle text-secondary text-xl mr-3 mt-1"></i>
                    <span>To ensure last-mile delivery of essential financial services</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-4">What We Do</h2>
              <p className="text-gray-600 text-lg">
                Edge Paisa offers a wide range of secure and technology-driven digital services
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Service 1 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp">
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-fingerprint text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">AEPS Services</h4>
                <p className="text-gray-600 text-center">
                  Aadhaar Enabled Payment Services for seamless transactions
                </p>
              </div>

              {/* Service 2 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-credit-card text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Micro ATM</h4>
                <p className="text-gray-600 text-center">
                  Cash Withdrawal & Balance Enquiry at your doorstep
                </p>
              </div>

              {/* Service 3 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-file-invoice-dollar text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Bill Payments & Recharges</h4>
                <p className="text-gray-600 text-center">
                  Mobile, DTH, electricity, and all utility bills in one place
                </p>
              </div>

              {/* Service 4 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-hand-holding-usd text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Loan & Credit Card Services</h4>
                <p className="text-gray-600 text-center">
                  Easy loan applications and credit card services
                </p>
              </div>

              {/* Service 5 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-shield-alt text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Insurance Services</h4>
                <p className="text-gray-600 text-center">
                  Life, health, and general insurance solutions
                </p>
              </div>

              {/* Service 6 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.5s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-id-card text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">PAN Services</h4>
                <p className="text-gray-600 text-center">
                  New PAN card applications and corrections
                </p>
              </div>

              {/* Service 7 */}
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition duration-300 animate-fadeInUp md:col-span-2 lg:col-span-3" style={{ animationDelay: '0.6s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-store text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Digital Dukan Setup Assistance</h4>
                <p className="text-gray-600 text-center max-w-2xl mx-auto">
                  Transform your shop into a complete digital service center with our comprehensive setup support
                </p>
              </div>
            </div>

            <div className="mt-12 text-center animate-fadeInUp" style={{ animationDelay: '0.7s' }}>
              <div className="bg-gradient-to-r from-primary to-secondary text-white p-6 rounded-lg inline-block">
                <p className="text-xl font-semibold">
                  With Edge Paisa, even the smallest shop can provide big services—making banking accessible for millions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Edge Paisa Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-4">Why Edge Paisa?</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp">
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-shield-alt text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3">Trusted & Transparent</h4>
                <p className="text-gray-600">
                  A reliable fintech platform you can trust
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-rupee-sign text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3">High-Earning Opportunities</h4>
                <p className="text-gray-600">
                  Attractive commission structure for retailers
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-laptop text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3">Easy-to-Use Dashboard</h4>
                <p className="text-gray-600">
                  User-friendly digital interface for all
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-lock text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3">Fast, Safe & Reliable</h4>
                <p className="text-gray-600">
                  Secure transactions with bank-grade security
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-headset text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3">Strong Support System</h4>
                <p className="text-gray-600">
                  Comprehensive training and ongoing support
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.5s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-network-wired text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3">Growing Network</h4>
                <p className="text-gray-600">
                  Expanding presence across Bharat
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Commitment Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-6">Our Commitment</h2>
              <p className="text-gray-700 text-lg mb-8">
                At Edge Paisa, we are committed to:
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4 animate-fadeInUp">
                <div className="bg-primary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-users text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Supporting Local Entrepreneurs</h4>
                  <p className="text-gray-600">
                    Empowering small business owners to grow and succeed
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="bg-secondary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-shield-alt text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Delivering Secure Digital Services</h4>
                  <p className="text-gray-600">
                    Ensuring every transaction is safe and protected
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-primary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-hands-helping text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Empowering Financial Inclusion</h4>
                  <p className="text-gray-600">
                    Bringing banking to the unbanked and underbanked
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="bg-secondary text-white w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="fas fa-globe text-xl"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Building a Strong Digital Ecosystem</h4>
                  <p className="text-gray-600">
                    Creating a connected and empowered Bharat
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 bg-gradient-to-r from-primary to-secondary text-white p-8 rounded-lg text-center animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
              <p className="text-2xl font-bold mb-4">
                We believe every shopkeeper can become a Digital Partner of Progress
              </p>
              <p className="text-xl">
                And every village can be digitally connected
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-primary to-secondary">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-5xl font-bold text-white mb-4 animate-fadeInUp">
            Edge Paisa
          </h2>
          <p className="text-white text-3xl font-semibold mb-6 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
            One Shop. Endless Services.
          </p>
          <p className="text-white text-xl mb-8 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
            Empowering Bharat, One Digital Dukan at a Time.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
            <Link
              to="/contact"
              className="bg-white text-primary hover:bg-gray-100 font-semibold py-4 px-8 rounded-full transition duration-300 inline-block"
            >
              Become a Digital Dukan
            </Link>
            <Link
              to="/contact"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary font-semibold py-4 px-8 rounded-full transition duration-300 inline-block"
            >
              Learn More
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EdgePaisa;